import { Container } from "./styles";

const Body = ({ ...rest }) => <Container {...rest} />;

export default Body;
